import { NgModule } from '@angular/core';
import { DentalEyeOpenPatientComponent } from './dentaleye-open-patient/dentaleye-open-patient.component';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { DentalEyeFeatureService } from './dentaleye-feature.service';

@NgModule({
  declarations: [DentalEyeOpenPatientComponent],
  imports: [NgSharedModule],
  providers: [DentalEyeFeatureService],
})
export class DentalEyeModule {}
